import { Button } from 'antd';
import styled from 'styled-components';

export const StyledButton = styled(Button)`
  .IconViewFilled {
    fill: ${({ theme, disabled }) => (disabled ? theme.colors.black4 : theme.colors.black9)};
  }
  .IconViewOffFilled {
    fill: ${({ theme, disabled }) => (disabled ? theme.colors.black4 : theme.colors.black9)};
  }
`;

export const ButtonText = styled.span`
  color: ${({ theme }) => theme.colors.black9};
`;
